import type { FC } from "react";

import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { ASC } from "app/components/React/Table/Utils/sort";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { WithAnimationContainer } from "app/UtilitiesAndConstants/UtilitiesComponents/WithAnimationContainer";

import type { OrderBy } from "../types";

export const TERM = "term";

const { carbon, sky } = colorsPalettes;
const HeaderContainer = styled(FlexRow)<{ isReversed }>`
    gap: 2px;
    cursor: pointer;
    ${setFontVariant("caption", carbon[250])};
    align-items: center;
    ${({ isReversed }) =>
        isReversed &&
        `
        flex-direction: row-reverse;
        gap: 6px;
    `}
`;

interface HeaderProps {
    orderBy: OrderBy;
    onClick: VoidFunction;
    text: string;
    isSorted: boolean;
}

export const Header: FC<HeaderProps> = ({ orderBy, onClick, text, isSorted }) => {
    const { sortDirection, field } = orderBy;
    const iconName = sortDirection === ASC ? "arrow-up" : "arrow-down";
    const isReversed = field === TERM;
    return (
        <HeaderContainer
            onClick={onClick}
            isReversed={isReversed}
        >
            {isSorted ? (
                <WithAnimationContainer key={iconName}>
                    <SWReactIcons
                        iconColor={sky[500]}
                        iconName={iconName}
                        size={"xs"}
                    />
                </WithAnimationContainer>
            ) : null}
            <span>{text}</span>
        </HeaderContainer>
    );
};
